<template>
  <!-- 我的二维码 -->
  <div class="page">
    <Header title="我的二维码" :show-back="true" />
    <div class="content">
    <div class="avator-wrap">
      <div class="avator-box">
        <img class="avator-img" :src="getImgUrl()" />
      </div>
    </div>
    <div class="qrcode-box">
      <div class="qrcode-wrap" ref="qrCode">
        <div id="qrcode"></div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import centerApi from '@/api/center'
import QRCode from 'qrcodejs2'
export default {
  components: {
    Header
  },
  data () {
    return {
      scanTotalCount: '',
      monthScanTotalCount: '',
      avatorUrl: '',
      clientInfo: {},
      qrcodeUrl: '',
      qrBoxHeight: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.qrBoxHeight = this.$refs.qrCode.offsetHeight
    })
    this.avatorUrl = this.clientInfo.avatarImageUri
    this.init()
  },
  methods: {
    async init () {
      // 获取跳转的链接
      let { data } = await centerApi.getClientInfo()
      console.log(data)
      let clientId = data.resultData.clientInfo.clientId
      this.qrcodeUrl = `${document.location.origin}/v2/register2?clientId=${clientId}&applyType=04`
      this.$nextTick(() => {
        this.crateQrcode()
      })
    },

    getImgUrl () {
      return process.env.VUE_APP_FILE_SERVER + this.avatorUrl
    },

    // 生成二维码
    crateQrcode () {
      this.qr = new QRCode('qrcode', {
        width: this.qrBoxHeight,
        height: this.qrBoxHeight,
        text: this.qrcodeUrl,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-top: 46px;
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.avator-wrap {
  width: 100%;
  height: 24%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  .avator-box {
    width: 70px;
    height: 70px;
    .avator-img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
.count-box {
  flex: 1;
}
.qrcode-box {
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #fff;
  box-sizing: border-box;
}
.qrcode-wrap {
  width: 100%;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.coupon-total {
  width: 100%;
  height: 40%;
  display: flex;
  align-items: center;
  padding-left: 50px;
  padding-top: 20px;
  font-size: 20px;
  box-sizing: border-box;
}
.scan-counts {
  width: 100%;
  height: 45%;
  display: flex;
  padding: 0 30px;
  box-sizing: border-box;
  .all-counts,
  .month-counts {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .all-counts {
    padding: 0 30px 0 25px;

  }
  .month-counts {
    padding: 0 20px 0 35px;
  }
  .all-counts {
    border-right: 1px dashed #cccccc;
  }
  .scan-text {
    width: 40%;
    font-size: 18px;
    line-height: 1.5;
  }
  .scan-count {
    width: 60%;
    font-size: 32px;
    color: #117281;
    font-weight: bold;
    text-align: right;
  }
}
</style>
